export default __webpack_public_path__ + "static/media/imone-img.a09ef412.webp";